export default __webpack_public_path__ + "static/media/caution.1f27152f.svg";